import React from 'react';
import { getEducationLabel } from './MaritalHistory';

const ReviewStep3 = ({ formData, updateFormData, nextStep, prevStep, goToStep }) => {
  const partyB = formData.partyB || {};
  const maritalHistory = partyB.maritalHistory || {};

  return (
    <div>
      <h1 className="form-section-title">Review - {partyB.role || 'Party B'} Information</h1>

      {/* Basic Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Party Type & Sex</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Party Type:</div>
          <div className="review-value">{partyB.role || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Sex:</div>
          <div className="review-value">{partyB.sex || 'Not provided'}</div>
        </div>
      </div>

      {/* Name Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Name Information</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">First Name:</div>
          <div className="review-value">{partyB.firstName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Middle Name:</div>
          <div className="review-value">{partyB.middleName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Last Name:</div>
          <div className="review-value">{partyB.lastName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Suffix:</div>
          <div className="review-value">{partyB.suffix || 'None'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Last Name Before Marriage:</div>
          <div className="review-value">{partyB.lastNameBeforeMarriage || 'Not provided'}</div>
        </div>
      </div>

      {/* Residence Address */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Residence Address</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Address:</div>
          <div className="review-value">{partyB.residenceAddress || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">City:</div>
          <div className="review-value">{partyB.city || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Parish/County:</div>
          <div className="review-value">{partyB.parish || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">State:</div>
          <div className="review-value">{partyB.state || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">ZIP:</div>
          <div className="review-value">{partyB.zip || 'Not provided'}</div>
        </div>
      </div>

      {/* Birth Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Birth Information</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Race:</div>
          <div className="review-value">{partyB.race || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Date of Birth:</div>
          <div className="review-value">{partyB.dateOfBirth || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - City:</div>
          <div className="review-value">{partyB.birthCity || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - State:</div>
          <div className="review-value">{partyB.birthState || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - Country:</div>
          <div className="review-value">{partyB.birthCountry || 'Not provided'}</div>
        </div>
      </div>

      {/* Mother/Parent Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Mother/Parent Information</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Mother/Parent's Name:</div>
          <div className="review-value">{partyB.motherName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - City:</div>
          <div className="review-value">{partyB.motherBirthCity || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - State:</div>
          <div className="review-value">{partyB.motherBirthState || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - Country:</div>
          <div className="review-value">{partyB.motherBirthCountry || 'Not provided'}</div>
        </div>
      </div>

      {/* Father/Parent Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Father/Parent Information</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Father/Parent's Name:</div>
          <div className="review-value">{partyB.fatherName || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - City:</div>
          <div className="review-value">{partyB.fatherBirthCity || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - State:</div>
          <div className="review-value">{partyB.fatherBirthState || 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Place of Birth - Country:</div>
          <div className="review-value">{partyB.fatherBirthCountry || 'Not provided'}</div>
        </div>
      </div>

      {/* Contact Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Contact Information</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Social Security Number:</div>
          <div className="review-value">
            {partyB.ssn ? `*****${partyB.ssn.slice(5)}` : 'Not provided'}
          </div>
        </div>
        <div className="review-item">
          <div className="review-label">SSN Confidential:</div>
          <div className="review-value">{partyB.ssnConfidential ? 'Yes' : 'No'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Phone Number:</div>
          <div className="review-value">{partyB.phoneNumber || partyB.phone || 'Not provided'}</div>
        </div>
      </div>

      {/* Marital History */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Marital History</h3>
          <button onClick={() => goToStep(11)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Number of Previous Marriages:</div>
          <div className="review-value">{maritalHistory.previousMarriages || 'Not provided'}</div>
        </div>
        {maritalHistory.previousMarriages && parseInt(maritalHistory.previousMarriages) > 0 && (
          <>
            <div className="review-item">
              <div className="review-label">Date Last Marriage Ended:</div>
              <div className="review-value">{maritalHistory.lastMarriageEndDate || 'Not provided'}</div>
            </div>
            <div className="review-item">
              <div className="review-label">Reason Last Marriage Ended:</div>
              <div className="review-value">{maritalHistory.lastMarriageEndReason || 'Not provided'}</div>
            </div>
          </>
        )}
        <div className="review-item">
          <div className="review-label">Highest Education Completed:</div>
          <div className="review-value">{getEducationLabel(maritalHistory.education)}</div>
        </div>
      </div>

      {/* Relationship Information */}
      <div className="review-section">
        <div className="review-section-header">
          <h3 className="form-subsection-title">Relationship Information</h3>
          <button onClick={() => goToStep(7)} className="btn btn-secondary review-edit-button">
            Edit
          </button>
        </div>
        <div className="review-item">
          <div className="review-label">Consanguineous Relationship:</div>
          <div className="review-value">{formData.isConsanguineous === true ? 'Yes' : formData.isConsanguineous === false ? 'No' : 'Not provided'}</div>
        </div>
        <div className="review-item">
          <div className="review-label">Covenant Marriage:</div>
          <div className="review-value">{formData.isCovenantMarriage === true ? 'Yes' : formData.isCovenantMarriage === false ? 'No' : 'Not provided'}</div>
        </div>
      </div>

      <div className="step-navigation">
        <button onClick={prevStep} className="btn btn-secondary">Back</button>
        <button onClick={nextStep} className="btn btn-primary">Next</button>
      </div>
    </div>
  );
};

export default ReviewStep3;
